import axios from 'axios';
import { API_URL, GYPSYBALL_PYTHON_API_URL, GYPSYBALL_PYTHON_API_TOKEN } from 'configs';

import { isEmpty } from 'lodash';
import { useDispatch } from 'react-redux';

import { v4 as uuidv4 } from 'uuid';
export const INCIDENT_PREVENTION_ACTION_REQUEST = 'INCIDENT_PREVENTION_ACTION_REQUEST';
export const INCIDENT_PREVENTION_ACTION_SUCCESS = 'INCIDENT_PREVENTION_ACTION_SUCCESS';
export const INCIDENT_PREVENTION_ACTION_VALIDATION_ERROR = 'INCIDENT_PREVENTION_ACTION_VALIDATION_ERROR';
const SHOW_SNACKBAR = 'SHOW_SNACKBAR';
export const HIDE_INCIDENT_PREVENTION_ACTION_FEILD_VALIDATION_ERROR = 'HIDE_INCIDENT_PREVENTION_ACTION_FEILD_VALIDATION_ERROR';
export const REDIRECT_TO_INCIDENT_PREVENTION_ACTION_LIST = 'REDIRECT_TO_INCIDENT_PREVENTION_ACTION_LIST';

export const INCIDENT_PREVENTION_ACTION_GET_SUCCESS = 'INCIDENT_PREVENTION_ACTION_GET_SUCCESS';
export const INCIDENT_PREVENTION_ACTION_DROPDOWN_LIST_SUCCESS = 'INCIDENT_PREVENTION_ACTION_DROPDOWN_LIST_SUCCESS';
export const INCIDENT_PREVENTION_ACTION_SERVER_SUCCESS = 'INCIDENT_PREVENTION_ACTION_SERVER_SUCCESS';


const SHOW_LOADER = 'SHOW_LOADER';
const HIDE_LOADER = 'HIDE_LOADER';




const showCommonLoader = (label = '') => ({
  type: SHOW_LOADER,
  common_loder_label: label
});
const hideCommonLoader = () => ({
  type: HIDE_LOADER
});

const incidentPreventionActionRequest = () => ({
  type: INCIDENT_PREVENTION_ACTION_REQUEST
});



export const incidentPreventionActionServerListSuccess = () => ({
  type: INCIDENT_PREVENTION_ACTION_SERVER_SUCCESS
});

const incidentPreventionActionListSuccess = incidentPreventionActionList => ({
  type: INCIDENT_PREVENTION_ACTION_SUCCESS,
  incidentPreventionActionList: incidentPreventionActionList
});


export const incidentPreventionActionFailure = notification => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: 'general_error'
});

const validationError = notification => ({
  type: INCIDENT_PREVENTION_ACTION_VALIDATION_ERROR,
  validation_error: notification
});
const tokenError = notification => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: 'token_expire'
});





const incidentPreventionActionAddUpadteSuccess = (message, action, dispatch) => {
  dispatch(incidentPreventionActionSuccessNotification(message));
  dispatch(redirectToIncidentPreventionActionList());
};




export const redirectToIncidentPreventionActionList = () => ({
  type: REDIRECT_TO_INCIDENT_PREVENTION_ACTION_LIST
});

const getIncidentPreventionActionSuccess = (response, action) => ({
  type: INCIDENT_PREVENTION_ACTION_GET_SUCCESS,
  record: response,
  actionType: action
});


const incidentPreventionActionSuccessNotification = message => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: message,
  snackbar_notification_type: 'success'
});


export const hideIncidentPreventionActionValidationError = feild_key => ({
  type: HIDE_INCIDENT_PREVENTION_ACTION_FEILD_VALIDATION_ERROR,
  feild_key: feild_key
});

export const incidentPreventionActionListFetch = (user_id) => {

  var token = localStorage.getItem('token');
  return dispatch => {
    dispatch(incidentPreventionActionRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + 'incidentPrevention/getAll', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: 'Bearer ' + token
      },

    }).then(
      response => {
        dispatch(hideCommonLoader());
        dispatch(incidentPreventionActionListSuccess(response.data));
      },
      error => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

export const addIncidentPreventionAction = data => {

  console.log('create_data', data)
  var token = localStorage.getItem('token');
  return dispatch => {
    dispatch(incidentPreventionActionRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + 'incidentPrevention/create', {
      method: 'POST',
      headers: {

        Accept: 'application/json',
        Authorization: 'Bearer ' + token
      },
      data: data
    }).then(
      response => {
        dispatch(hideCommonLoader());
        incidentPreventionActionAddUpadteSuccess(
          'IncidentPreventionAction Added Successfully',
          'create',
          dispatch
        );

      },
      error => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
        // dispatch(workspaceFailure("The name has already been taken"))
      }
    );
  };
};









export const updateIncidentPreventionAction = (data) => {

  console.log('update_data', data)
  // return
  const id = data.id; // Make sure `id` exists on `data`
  const token = localStorage.getItem('token');

  return async (dispatch) => {
    dispatch(incidentPreventionActionRequest());
    dispatch(showCommonLoader());

    try {
      await axios(API_URL + 'incidentPrevention/update/' + id, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + token,
        },
        data: data, // send whole object (must match Laravel expectations)
      });

      incidentPreventionActionAddUpadteSuccess(
        'IncidentPreventionAction Updated Successfully',
        'update',
        dispatch
      );

    } catch (error) {
      handleErrorResponse(error, dispatch);
    } finally {
      dispatch(hideCommonLoader());
    }
  };
};

export const updateImoPreventionAction = (data) => {

  const token = localStorage.getItem('token');

  return async (dispatch) => {
    dispatch(incidentPreventionActionRequest());
    dispatch(showCommonLoader());

    try {
      await axios(API_URL + 'incidentPrevention/updateImoChanges', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + token,
        },
        data: data, // send whole object (must match Laravel expectations)
      });

      incidentPreventionActionAddUpadteSuccess(
        'IncidentPreventionAction Updated Successfully',
        'update',
        dispatch
      );

    } catch (error) {
      handleErrorResponse(error, dispatch);
    } finally {
      dispatch(hideCommonLoader());
    }
  };
};






export const getIncidentPreventionActionById = (id, action) => {
  var token = localStorage.getItem('token');
  return dispatch => {
    dispatch(incidentPreventionActionRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + 'incidentPrevention/getById/' + id, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: 'Bearer ' + token
      }
    }).then(
      response => {
        dispatch(hideCommonLoader());
        dispatch(getIncidentPreventionActionSuccess(response.data, action));
      },
      error => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};


export const deleteIncidentPreventionAction = (id, object_viewed_id) => {
  var token = localStorage.getItem('token');
  return dispatch => {
    dispatch(incidentPreventionActionRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + 'incidentPrevention/delete/' + id, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: 'Bearer ' + token
      },
      data: {
        object_viewed_id
      }
    }).then(
      response => {
        dispatch(hideCommonLoader());
        dispatch(
          incidentPreventionActionSuccessNotification('IncidentPreventionAction deleted successfully')
        );
      },
      error => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};




// handling error reponse
const handleErrorResponse = (error, dispatch) => {
  try {
    if (error.response.status === 422 && error.response.data.error) {

      dispatch(validationError(error.response.data.error));
    } else if (error.response.status === 401 && error.response.data.error) {
      dispatch(tokenError(error.response.data.error.toString()));
    } else {
      let err = '';
      if (error.response.data.error) {
        err = error.response.data.error.toString();
      } else {
        err = error.response.status + ` ` + error.response.statusText;
      }
      dispatch(incidentPreventionActionFailure(err));
    }
  } catch (e) {
    dispatch(incidentPreventionActionFailure('Unable to perform action.Something went wrong'));
  }
};





























